module.exports = __webpack_public_path__ + "img/sendtopaymentgateway.1a99292.png";